import hoist from 'hoist-non-react-statics';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import getDisplayName from '../../../../utils/displayName';
import { INSURANCE_CARRIER_KEY, INSURANCE_PLAN_KEY } from './constants';

export default function addInsuranceToUrls(WrappedComponent) {
    class TimesGridInsuranceWrapper extends Component {
        static WrappedComponent = WrappedComponent;
        static displayName = `InsuranceWrapped(${getDisplayName(WrappedComponent)})`;

        static propTypes = {
            insuranceCarrierId: PropTypes.string,
            insurancePlanId: PropTypes.string,
            onTimeSlotClicked: PropTypes.func,
        };

        static defaultProps = {
            onTimeSlotClicked: noop,
        };

        onTimeSlotClicked = (timeslot, event) => {
            const { onTimeSlotClicked, insuranceCarrierId, insurancePlanId } = this.props;

            if (insuranceCarrierId && insurancePlanId) {
                if (insuranceCarrierId && parseInt(insuranceCarrierId, 10) > 0) {
                    const carrierQuery = `&${INSURANCE_CARRIER_KEY}=${insuranceCarrierId}`;

                    timeslot.url += carrierQuery;
                    event.currentTarget.href += carrierQuery;
                }

                if (insurancePlanId && parseInt(insurancePlanId, 10) > 0) {
                    const planQuery = `&${INSURANCE_PLAN_KEY}=${insurancePlanId}`;

                    timeslot.url += planQuery;
                    event.currentTarget.href += planQuery;
                }
            }

            onTimeSlotClicked(timeslot, event);
        }

        render() {
            const { insuranceCarrierId, insurancePlanId } = this.props;
            const passProps = {
                ...this.props,
                insuranceCarrierId,
                insurancePlanId,
            };

            return (
                <WrappedComponent
                    {...passProps}
                    onTimeSlotClicked={this.onTimeSlotClicked}
                />
            );
        }
    }

    hoist(TimesGridInsuranceWrapper, WrappedComponent);

    return TimesGridInsuranceWrapper;
}
